module.exports = __webpack_public_path__ + "static/media/xSCREAM.f11a3cc5.png";